import React, { useCallback, useState } from 'react';

import { IChangeEvent } from '@rjsf/core';
import Form from '@rjsf/mui';
import { UiSchema } from '@rjsf/utils';
import validator from '@rjsf/validator-ajv8';
import { useSnackbar } from 'notistack';

import { Box } from '@mui/material';

import VendorsService from '~/services/VendorsService';

const uiSchema: UiSchema = {
  fk_offer: { 'ui:widget': 'hidden' },
  fk_vendor: { 'ui:widget': 'hidden' },
  fk_added_by: { 'ui:widget': 'hidden' },
  date_of_adjustment: {
    'ui:placeholder': '31/12/2017',
    'ui:widget': 'date',
    'ui:title': 'Date of Payment',
  },
  currency: {
    'ui:widget': 'select',
    'ui:title': 'Payment currency',
  },
  amount: {
    'ui:placeholder': '0',
    'ui:widget': 'text',
    'ui:title': 'Payment amount',
  },
  description: {
    'ui:widget': 'textarea',
    'ui:title': 'Description',
  },
};

interface Props {
  schema: any;
  offerId: string;
  vendorId: string;
  onErrorPaymentAdded: (errorPayment: Record<string, unknown>) => void;
}

export function ErrorPaymentsAddForm(props: Props) {
  const { enqueueSnackbar } = useSnackbar();

  const [formData] = useState({
    date_of_adjustment: new Date().toISOString().slice(0, 10),
    fk_offer: props.offerId,
    fk_vendor: props.vendorId,
    currency: 'AUD',
    amount: '0',
    description: '',
  });

  const onErrorPaymentAdded = props.onErrorPaymentAdded;

  const validationHandler = useCallback((data, errors) => {
    const amount = Number.parseFloat(data.amount);

    if (!Number.isFinite(amount)) {
      errors.amount.addError('should be a number');
    }

    return errors;
  }, []);

  const submitHandler = useCallback(
    async (e: IChangeEvent) => {
      try {
        const res = await VendorsService.createErrorPayment(e.formData);
        enqueueSnackbar(`Error payment saved`, { variant: 'success' });
        onErrorPaymentAdded(res.result);
      } catch (err) {
        enqueueSnackbar(`Can't save error payment: ${err.message}`, { variant: 'error' });
      }
    },
    [onErrorPaymentAdded, enqueueSnackbar],
  );

  return (
    <Box id="errorpayments-form" mb={2}>
      <Form
        schema={props.schema}
        uiSchema={uiSchema}
        onSubmit={submitHandler}
        customValidate={validationHandler}
        validator={validator}
        formData={formData}
      />
    </Box>
  );
}
